import { NgModule } from 'ng-metadata/core';
import {TagsListService} from './tagsList.service';
import {PrmTagsList} from './tagsList.directive';

@NgModule({
    declarations: [
        PrmTagsList
    ],
    providers: [
        TagsListService
    ],
    imports:[

    ]
})
export class TagsListModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tagsList/tagsList.module.ts